// App.jsx
import React from 'react';
import './App.css';
// Import placeholder images (you'd replace these with your actual image paths)
import heroImage from './assets/hero-image3.jpg'; // Example path
import mlIcon from './assets/ml-icon.png';
import nlpIcon from './assets/nlp-icon.png';
import cvIcon from './assets/cv-icon.png';
import aboutImage from './assets/about-image.jpg';

function App() {
  return (
    <div className="App">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="logo">AllegroInsights</div>
          <nav>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="container">
          <img src={heroImage} alt="AI Innovation" className="hero-image" />
          <h1>Transforming Business with AI Innovation</h1>
          <p>Harness the power of artificial intelligence with AllegroInsights</p>
          <button className="cta-button">Get Started</button>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services">
        <div className="container">
          <h2>Our AI Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <img src={mlIcon} alt="Machine Learning" className="service-icon" />
              <h3>Machine Learning</h3>
              <p>Custom ML solutions for predictive analytics and data-driven decisions</p>
            </div>
            <div className="service-card">
              <img src={nlpIcon} alt="Natural Language Processing" className="service-icon" />
              <h3>Natural Language Processing</h3>
              <p>Advanced NLP for text analysis and intelligent chatbots</p>
            </div>
            <div className="service-card">
              <img src={cvIcon} alt="Computer Vision" className="service-icon" />
              <h3>Computer Vision</h3>
              <p>AI-powered image and video analysis solutions</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="container">
          <h2>About AllegroInsights</h2>
          <img src={aboutImage} alt="Our Team" className="about-image" />
          <p>
            At AllegroInsights, we're passionate about leveraging AI to drive business success. 
            Our team of experts combines cutting-edge technology with industry expertise to 
            deliver transformative solutions tailored to your needs.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="container">
          <h2>Contact Us</h2>
          <form>
            <input type="text" placeholder="Name" required />
            <input type="email" placeholder="Email" required />
            <textarea placeholder="Message" required></textarea>
            <button type="submit">Send Message</button>
          </form>
        </div>
      </section>

      {/* Footer */}
      <footer>
        <div className="container">
          <p>© 2025 AllegroInsights. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;